import { apiClient } from './apiClient';
const BASE_URL = '/api/v1/shipments';
/**
 * Get all shipments with optional filters and pagination
 */
export async function getShipments(params) {
    const searchParams = new URLSearchParams();
    if (params?.status)
        searchParams.append('status', params.status);
    if (params?.mode)
        searchParams.append('mode', params.mode);
    if (params?.search)
        searchParams.append('search', params.search);
    if (params?.page)
        searchParams.append('page', params.page.toString());
    if (params?.pageSize)
        searchParams.append('pageSize', params.pageSize.toString());
    const response = await apiClient.get(`${BASE_URL}?${searchParams.toString()}`);
    return response.data;
}
/**
 * Get a single shipment by ID
 */
export async function getShipment(id) {
    const response = await apiClient.get(`${BASE_URL}/${id}`);
    return response.data;
}
/**
 * Get detailed shipment information including items and containers
 */
export async function getShipmentDetails(id) {
    const response = await apiClient.get(`${BASE_URL}/${id}/details`);
    return response.data;
}
/**
 * Create a new shipment
 */
export async function createShipment(data) {
    const response = await apiClient.post(BASE_URL, data);
    return response.data;
}
/**
 * Update a shipment
 */
export async function updateShipment(id, data) {
    // Check if this is a full details update (has items or containers)
    if ('items' in data || 'containers' in data) {
        const response = await apiClient.put(`${BASE_URL}/${id}/details`, data);
        return response.data;
    }
    else {
        const response = await apiClient.put(`${BASE_URL}/${id}`, data);
        return response.data;
    }
}
/**
 * Delete a shipment
 */
export async function deleteShipment(id) {
    const response = await apiClient.delete(`${BASE_URL}/${id}`);
    return response.data;
}
/**
 * Get shipment events
 */
export async function getShipmentEvents(id) {
    const response = await apiClient.get(`${BASE_URL}/${id}/events`);
    return response.data;
}
/**
 * Cross-validate documents for a shipment
 */
export async function crossValidateShipmentDocuments(shipmentId, documentIds) {
    const response = await apiClient.post(`${BASE_URL}/${shipmentId}/documents/cross-validate`, { documentIds }, {
        timeout: 90000,
    });
    return response.data;
}
/**
 * Merge documents for a shipment
 */
export async function mergeShipmentDocuments(shipmentId, documentIds) {
    const response = await apiClient.post(`${BASE_URL}/${shipmentId}/documents/merge`, { documentIds });
    return response.data;
}
/**
 * Validate documents for a shipment
 */
export async function validateShipmentDocs(shipmentId, documentIds) {
    const response = await apiClient.post(`${BASE_URL}/${shipmentId}/documents/validate`, { documentIds });
    return response.data;
}
